import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ReactGA from 'react-ga';
import SmoothScroll from "smooth-scroll";

import { Landing } from "./layouts/Landing/landing";
import { Legal } from "./layouts/Legal/legal";
import { About } from "./layouts/About/about";
import { NGO } from "./layouts/NGO/ngo";
import { Technology } from "./layouts/Technology/technology";
import { Foundations } from "./layouts/Foundations/foundations";
import { Login } from "./layouts/Login/login";
import { Minting } from "./layouts/Mint/minting";
import { Whitelist } from "./layouts/Whitelist/whitelist";
import { Contact } from "./components/Contact/contact";
import { Footer } from "./components/Footer/footer";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {

  useEffect(()=>{
    if(!window.GA_INITIALIZED){
      ReactGA.initialize('G-JMBP4KTF8F');
      window.GA_INITIALIZED = true;
    }
    ReactGA.pageview("/" + window.location.search);
  },[])

  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" exact element={<Landing/>} />
          <Route path="/legal" exact element={<Legal/>} />
          <Route path="/about" exact element={<About/>} />
          <Route path="/ngo" exact element={<NGO/>} />
          <Route path="/technology" exact element={<Technology/>} />
          <Route path="/foundations" exact element={<Foundations/>} />
          <Route path="/login" exact element={<Login/>}/>
          <Route path="/mint" exact element={<Minting/>}/>
          <Route path="/whitelist" exact element={<Whitelist/>}/>
          <Route
              path="*"
              element={<Navigate to="/" replace />}
          />
        </Routes>
        <Contact />
        <Footer />
      </Router>
    </div>
  );
};

export default App;